

import { HttpClient } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
// import { Configuration } from './../configuration/configuration';
import { Observable } from 'rxjs';

@Injectable()
export class RolService extends HttpClientBaseService {

  constructor(_http: HttpClient) {
    super(_http, 'account/roles/');
  }

  public getAllRoles(): Observable<string[]> {
    return super.getAll<string[]>();
  }
}
